/**
 * Utilitaire pour gérer la traduction des erreurs QR codes
 */

const BACKEND_TO_FRONTEND_QR_KEYS = {
  'qr_codes.validation.expired': 'qrCodes:validation.expired',
  'qr_codes.validation.invalid': 'qrCodes:validation.invalid',
  'qr_codes.validation.not_yet_valid': 'qrCodes:validation.not_yet_valid',
  'qr_codes.validation.wrong_user': 'qrCodes:validation.wrong_user',
  'qr_codes.validation.wrong_reservation': 'qrCodes:validation.wrong_reservation',
  'qr_codes.validation.wrong_status': 'qrCodes:validation.wrong_status',
  'qr_codes.validation.scan_failed': 'qrCodes:validation.scan_failed',
  'qr_codes.validation.general_error': 'qrCodes:validation.general_error'
};

const STATUS_TO_TRANSLATION_KEY = {
  expired: 'qrCodes:validation.expired',
  invalid: 'qrCodes:validation.invalid',
  not_yet_valid: 'qrCodes:validation.not_yet_valid',
  wrong_user: 'qrCodes:validation.wrong_user'
};

const resolveFrontendTranslationKey = (translationKey, status) => {
  if (translationKey && BACKEND_TO_FRONTEND_QR_KEYS[translationKey]) {
    return BACKEND_TO_FRONTEND_QR_KEYS[translationKey];
  }

  if (typeof translationKey === 'string' && translationKey.startsWith('qrCodes:')) {
    return translationKey;
  }

  if (!status || typeof status !== 'string') {
    return null;
  }

  return STATUS_TO_TRANSLATION_KEY[status.toLowerCase()] || null;
};

/**
 * Traduit une erreur QR à partir d'une clé de traduction backend ou d'un status stable
 * @param {string|Object} errorInput - Erreur backend (message ou objet enrichi)
 * @param {Function} t - Fonction de traduction i18next
 * @returns {string} - Message traduit
 */
export const translateQRError = (errorInput, t) => {
  if (!errorInput) {
    return t('qrCodes:validation.general_error');
  }

  if (typeof errorInput === 'object') {
    const frontendKey = resolveFrontendTranslationKey(
      errorInput.translationKey || errorInput.details?.translationKey,
      errorInput.status || errorInput.details?.status
    );

    if (frontendKey) {
      return t(frontendKey);
    }
  }

  if (typeof errorInput === 'string') {
    const frontendKey = resolveFrontendTranslationKey(errorInput, errorInput);
    if (frontendKey) {
      return t(frontendKey);
    }
  }

  return t('qrCodes:validation.general_error');
};

/**
 * Obtient le message de succès approprié pour le type d'action
 * @param {string} type - Type d'action ('pickup' ou 'return')
 * @param {Function} t - Fonction de traduction i18next
 * @returns {string} - Message de succès traduit
 */
export const getQRSuccessMessage = (type, t) => {
  if (type === 'pickup') {
    return t('qrCodes:confirmation.pickup_success');
  } else if (type === 'return') {
    return t('qrCodes:confirmation.return_success');
  }
  return t('qrCodes:confirmation.success');
};

/**
 * Obtient le message d'erreur technique
 * @param {Function} t - Fonction de traduction i18next
 * @returns {string} - Message d'erreur technique traduit
 */
export const getQRTechnicalError = (t) => {
  return t('qrCodes:confirmation.technical_error');
};
